import { render, staticRenderFns } from "./CustodyExpenseForm.vue?vue&type=template&id=b83a51c4&"
import script from "./CustodyExpenseForm.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports